// Central site configuration for Angmish General Dealer
export const COMPANY = {
  name: "Angmish General Dealers",
  short: "Angmish",
  tagline: "Mining & Heavy Machinery Parts. Nationwide Zambia.",
  address: "Chilenje South, Chuswe Rd 13129, Lusaka, Zambia",
  phones: [
    { label: "Lusaka", value: "+260 97 1061412", href: "tel:+260971061412" },
    { label: "Lusaka", value: "+260 77 2022785", href: "tel:+260772022785" },
    { label: "USA", value: "+1 (678) 989 9752", href: "tel:+16789899752" },
  ],
  whatsapp: "https://wa.me/260971061412",
};

export const SHIPPING_TIERS = [
  {
    code: "01",
    name: "Air Shipping",
    time: "7 Days",
    detail: "Fastest air freight for urgent breakdowns and critical spares.",
    featured: false,
  },
  {
    code: "02",
    name: "Express Expedited",
    time: "2 Weeks",
    detail: "Our #1 choice — the best balance of speed and value.",
    featured: true,
  },
  {
    code: "03",
    name: "Regular Shipping",
    time: "6–8 Weeks",
    detail: "Economical sea freight for planned, bulk orders and heavy machinery.",
    featured: false,
  },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "One Supplier, Every Part",
    body: "From a single air filter to a full crane — if a mine runs it, we source it. No fragmented suppliers, no runaround.",
  },
  {
    n: "02",
    title: "Machinery To Own",
    body: "Excavators, backhoe loaders, haul trucks, drills and plant — sourced for you to purchase and own, never for hire. If we don't stock it, we find it.",
  },
  {
    n: "03",
    title: "Nationwide Reach",
    body: "Based in Lusaka, delivering across the entire Copperbelt and every corner of Zambia.",
  },
  {
    n: "04",
    title: "Shipping On Your Terms",
    body: "Air in 7 days, Express Expedited in 2 weeks, or Regular sea freight in 2–3 months. You set the pace.",
  },
];

export const FALLBACK_CATEGORIES = [
  { slug: "excavators", title: "Excavators", blurb: "Tracked & wheeled excavators, hydraulics and undercarriage parts.", image: "https://images.unsplash.com/photo-1587919968590-fbc98cea6c9a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxtaW5pbmclMjBleGNhdmF0b3J8ZW58MHx8fHwxNzg1Mzg3NzY4fDA&ixlib=rb-4.1.0&q=85" },
  { slug: "cranes", title: "Cranes", blurb: "Mobile, crawler and tower cranes plus lifting components.", image: "https://images.unsplash.com/photo-1586458995526-09ce6839babe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxoZWF2eSUyMG1hY2hpbmVyeSUyMGNyYW5lfGVufDB8fHx8MTc4NTM4Nzc2OHww&ixlib=rb-4.1.0&q=85" },
];
